import { useContext } from 'react';
import { AuthServiceContext } from './AuthServiceProvider';
import isElectron from 'is-electron';
import { generatePKCE } from './authservice.utils';
import { getElectronAPI } from 'flow/utils/electron-api';
import { AuthLoginParamType } from './authtypes';

export const useAuthService = () => {
    const authContext = useContext(AuthServiceContext);
    if (!authContext) {
        throw new Error(
            'useAuthService must be used within an AuthServiceProvider',
        );
    }

    const {
        keycloak,
        authenticated: isAuthenticated,
        isAuthLoading,
        logout: authLogout,
        isAuthServiceEnabled,
    } = authContext;

    const authLogin = async () => {
        if (isElectron()) {
            const electronAPI = getElectronAPI();
            if (electronAPI) {
                try {
                    const { codeVerifier, codeChallenge } =
                        await generatePKCE();
                    const authParameters = {
                        url: keycloak?.authServerUrl,
                        realm: keycloak?.realm,
                        clientId: keycloak?.clientId,
                        codeChallenge: codeChallenge,
                        codeChallengeMethod: 'S256',
                    } as AuthLoginParamType;
                    sessionStorage.setItem('pkce_code_verifier', codeVerifier);
                    await electronAPI.authServiceLogin(authParameters);
                } catch (error) {
                    console.error(
                        'Failed to complete Electron auth flow:',
                        error,
                    );
                }
            }
        } else {
            keycloak?.login();
        }
    };

    const token = keycloak?.token;

    return {
        authLogin,
        authLogout,
        isAuthenticated,
        token,
        isAuthLoading,
        isAuthServiceEnabled,
    };
};
